import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 ' +
    'focus-visible:ring-offset-bg-base disabled:pointer-events-none disabled:opacity-50 ' +
    'motion-reduce:transition-none', {
    variants: {
        variant: {
            // The one action colour, uniform across every theme. Distinct from `danger` by design:
            // those two used to be the same red, so "Analyze this file" and "Delete permanently" were
            // indistinguishable at a glance.
            primary: 'bg-cta text-cta-fg hover:bg-cta-hover active:bg-cta-hover',
            secondary: 'bg-bg-overlay text-text-primary border border-border-default hover:border-border-strong',
            ghost: 'text-text-secondary hover:bg-bg-overlay hover:text-text-primary',
            danger: 'bg-status-danger text-white hover:opacity-90',
            link: 'text-accent-500 underline-offset-4 hover:underline',
        },
        size: {
            sm: 'h-8 px-3 text-sm',
            md: 'h-10 px-4 text-sm',
            lg: 'h-12 px-6 text-base',
            icon: 'h-10 w-10',
        },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
});
export const Button = React.forwardRef(({ className, variant, size, loading, disabled, children, ...rest }, ref) => (_jsxs("button", { ref: ref, className: cn(buttonVariants({ variant, size }), className), disabled: disabled || loading, "aria-busy": loading || undefined, ...rest, children: [loading && (_jsx("span", { "aria-hidden": true, className: "h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent motion-reduce:animate-none" })), children] })));
Button.displayName = 'Button';
export { buttonVariants };
//# sourceMappingURL=button.js.map